import { CalendarPlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import OpenOfficeAgendaSlotForm from '@/components/forms/open-office-agenda-slot/open-office-agenda-slot-form';
import { Sheet } from '@/components/ui/sheet';
import { OpenOfficeAgendaSlotResponse } from '@/hooks/mutations/use-open-office-agenda-slot';
import { OfficeDoctorAttendingItem } from '@/hooks/queries/use-get-office';
import { selectSheetViewModel } from '../sheet.viewmodel';
import {
  SlotFormSheetActions,
  SlotFormSheetHeader,
} from '../slot-sheet/slot-form-sheet';
import {
  SlotSheetBody,
  SlotSheetContent,
} from '../slot-sheet/slot-sheet-shell';
import { selectAddOfficeAgendaSlotSheetViewModel } from './open-office-agenda-slot-sheet.viewmodel';

export type OpenOfficeAgendaSlotSheetApi = {
  onClose: (
    params:
      | {
          success: true;
          data: OpenOfficeAgendaSlotResponse;
        }
      | {
          success: false;
        },
  ) => void;
};

export const OpenOfficeAgendaSlotSheet = ({
  officeId,
  doctorAttendings,
  startDate,
  onClose,
}: {
  officeId: string;
  doctorAttendings: OfficeDoctorAttendingItem[];
  /** Day preselected when the sheet is opened from a calendar cell. */
  startDate?: Date;
} & OpenOfficeAgendaSlotSheetApi) => {
  const { t } = useTranslation();
  const sheetViewModel = selectSheetViewModel({
    sheetName: 'OpenOfficeAgendaSlotSheet',
    api: {
      onClose,
    },
  });
  const viewModel = selectAddOfficeAgendaSlotSheetViewModel({
    officeId,
    doctorAttendings,
    startDate,
    sheetViewModel,
  });

  const selectedDates = viewModel.form.watch('specificDates');

  return (
    <Sheet
      open={sheetViewModel.data.show}
      onOpenChange={sheetViewModel.api.onOpenChange}
    >
      <SlotSheetContent size="form">
        <SlotFormSheetHeader
          icon={CalendarPlusIcon}
          title={t('open-office-slot-sheet.title')}
          description={t('open-office-slot-sheet.description')}
        />

        <SlotSheetBody className="px-6 py-5">
          <OpenOfficeAgendaSlotForm
            form={viewModel.form}
            doctorAttendings={doctorAttendings}
          />
        </SlotSheetBody>

        <SlotFormSheetActions
          onReset={() => viewModel.form.reset()}
          onSubmit={viewModel.submit}
          submitting={viewModel.submitting}
          selectedCount={selectedDates.length}
        />
      </SlotSheetContent>
    </Sheet>
  );
};
